import type { ReactNode } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconAlert } from '#src/atoms/icons/system/iconAlert.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyL, HeadlineS } from '#src/atoms/typography/index.tsx';

const Root = styled.div`
  padding: var(--intermediate-unit);
  width: 100%;
  background:
    linear-gradient(0deg, var(--c-surface-caution), var(--c-surface-caution)),
    var(--c-black);
  border: 1px solid var(--c-yellow-400);
  border-radius: var(--unit);
`;

type Props = {
  title: ReactNode;
  message?: ReactNode;
  icon?: ReactNode;
};
export const Alert = ({ title, message, icon }: Props) => {
  return (
    <Root>
      <Horizontal as={HeadlineS} gap={0.5}>
        {icon ?? (
          <FontAwesomeIcon icon={iconAlert} color="var(--c-yellow-400)" />
        )}
        {title}
      </Horizontal>
      {typeof message === 'string' ? <BodyL>{message}</BodyL> : message}
    </Root>
  );
};
